/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Sc_PaletteInputs */

const en_mk_tut_sc_palette = /** @type {(inputs: Mk_Tut_Sc_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the command box: jump to any page or search issues`)
};

const id_mk_tut_sc_palette = /** @type {(inputs: Mk_Tut_Sc_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka kotak perintah: lompat ke halaman mana pun atau cari issue`)
};

/**
* | output |
* | --- |
* | "Open the command box: jump to any page or search issues" |
*
* @param {Mk_Tut_Sc_PaletteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_sc_palette = /** @type {((inputs?: Mk_Tut_Sc_PaletteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Sc_PaletteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_sc_palette(inputs)
	return en_mk_tut_sc_palette(inputs)
});